import { render, staticRenderFns } from "./QuestionSteam.vue?vue&type=template&id=792edf7f&scoped=true&"
import script from "./QuestionSteam.vue?vue&type=script&lang=js&"
export * from "./QuestionSteam.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSteam.vue?vue&type=style&index=0&id=792edf7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792edf7f",
  null
  
)

component.options.__file = "QuestionSteam.vue"
export default component.exports